export var Branch;
(function (Branch) {
    Branch["CLEAR"] = "clear";
    Branch["CONFIG"] = "config";
    Branch["ME"] = "me";
    Branch["PLAYER_DATA"] = "playerData";
    Branch["PLAYER_STATUS"] = "playerStatus";
    Branch["PLAYER_PERMISSIONS"] = "playerPermissions";
    Branch["PLAYER_RANK_INFO"] = "playerRankInfo";
    Branch["PLAYER_CONFIG"] = "playerConfig";
    Branch["AGENT_INFO"] = "agentInfo";
    Branch["FEATURE_FLAG"] = "featureFlag";
    Branch["MAIN_CASH"] = "mainCash";
    Branch["PLATFORMS"] = "platforms";
    Branch["PUBLISHERS"] = "publishers";
    Branch["BET_LIMIT"] = "betLimit";
    Branch["MY_BET"] = "myBet";
    Branch["MY_SUBSCRIPTION"] = "mySubscription";
    Branch["LOTTERY_ATTR"] = "lotteryAttr";
    Branch["LOTTERY_STATUS"] = "lotteryStatus";
    Branch["PUBLISHER_STATUS"] = "publisherStatus";
    Branch["LOTTERY_PARAMETERS"] = "lotteryParameters";
    Branch["LOTTERY_BET_LIMIT"] = "lotteryBetLimit";
    Branch["DEBIT_CARD"] = "debitCard";
    Branch["SUPPORT_BANK"] = "supportBank";
    Branch["FORWARDERS"] = "forwarders";
    Branch["HISTORY_NUMBER"] = "historyNumber";
    Branch["HISTORY_BET"] = "historyBet";
    Branch["HISTORY_SUBSCRIPTION"] = "historySubscription";
    Branch["CASH_FLOW"] = "cashFlow";
    Branch["NOTIFICATION_IS_READ"] = "notificationIsRead";
    Branch["ANNOUNCEMENT"] = "announcement";
    Branch["STAFF_ANNOUNCEMENT"] = "staffAnnouncement";
    Branch["CASH_FLOW_DEPOSIT_METHODS"] = "cashFlowDepositMethods";
    Branch["CASH_FLOW_WITHDRAW_PARAMETERS"] = "cashFlowWithdrawParameters";
    Branch["CASH_FLOW_WITHDRAW_METHODS"] = "cashFlowWithdrawMethods";
    Branch["CASH_FLOW_WITHDRAW_TIPS"] = "cashFlowWithdrawTips";
    Branch["AGENT_USER_STATUS"] = "agentUserStatus";
    Branch["AGENT_STAFF_LIST"] = "agentStaffList";
    Branch["AGENT_LAYER"] = "agentLayer";
    Branch["PLAYER_LAYER"] = "playerLayer";
    Branch["ADMIN_ALERT_RECENT"] = "adminAlertRecent";
    Branch["ADMIN_FINANCE_ALERT"] = "adminFinanceAlert";
    Branch["ADMIN_COMPLAIN_ALERT"] = "adminComplainAlert";
    Branch["ADMIN_WITHDRAW_SLIP_ACCOUNTING"] = "adminWithdrawSlipAccounting";
    Branch["ADMIN_STATUS"] = "adminStatus";
    Branch["AGENT_STATUS"] = "agentStatus";
    Branch["ACTIVITY"] = "activity";
    Branch["ALIVE"] = "alive";
    Branch["GUEST"] = "guest";
    Branch["CASES"] = "cases";
    Branch["MESSAGES"] = "messages";
    Branch["NEW_MESSAGE_CHECK"] = "newMessageCheck";
    Branch["CUSTOMER_SERVICE_LIST"] = "customerServiceList";
    Branch["HEARTBEAT"] = "heartbeat";
    Branch["PM_PLAYER_AMOUNT"] = "pmPlayerAmount";
    Branch["CHATROOM_INFO"] = "chatroomInfo";
})(Branch || (Branch = {}));
//# sourceMappingURL=Branch.js.map